uniform float uTime;
uniform float uBeamingAngle;  
uniform float uBeamingStrength;
uniform float uBeamingFactor; 
uniform sampler2D uGradientTexture;
uniform sampler2D uNoisesTexture;

#pragma glslify: remap = require('../partials/remap.glsl')

varying vec2 vUv;


void main() {
  float n1 = texture(uNoisesTexture, vUv - uTime * 1.0).r;
  float n2 = texture(uNoisesTexture, vUv - uTime * 0.8).g;
  float n3 = texture(uNoisesTexture, vUv - uTime * 0.6).b;
  float n4 = texture(uNoisesTexture, vUv - uTime * 0.4).a;
  float noiseLen = length(vec4(n1, n2, n3, n4));

  float outerFall = remap(vUv.y, 0.2, 0.0, 1.0, 0.0);
  float innerFall = remap(vUv.y, 1.0, 0.95, 0.0, 1.0);
  float falloff  = smoothstep(0.0, 1.0, min(outerFall, innerFall));

  vec2 uv = vUv;
  uv.y += noiseLen * 0.6;
  uv.y *= falloff;
  vec4 color = texture(uGradientTexture, uv);
  float theta = (vUv.x - 0.5) * 2.0 * 3.141592653589793;
  float ba = radians(-uBeamingAngle+180.0);
  float rawBeam = max(0.0, cos(theta - ba) * 0.5 + 0.5);
  float beam = pow(rawBeam, uBeamingStrength);
  float finalBeam = mix(1.0, beam, clamp(uBeamingFactor, 0.0, 1.0));

  color.a = uv.y * finalBeam;

  gl_FragColor = color;
}
